'use client';

import React from 'react';

import { TasticProps } from 'frontastic/tastics/types';
import  {ExperienceCenterLocationSpecificProps} from 'components/commercetools-ui/organisms/experience-center/location-specific';
import ExperienceCenterLandingPage from 'components/commercetools-ui/organisms/experience-center';
import PrivacyPage from 'components/commercetools-ui/organisms/content/privacy-page';


const PrivacyPageTastic  = ({ data }: TasticProps<ExperienceCenterLocationSpecificProps>) => {
  return <PrivacyPage data={data?.data?.dataSource} />;
};

export default PrivacyPageTastic;